import { nanoid } from "nanoid";
var TYPE = "TRACK_EVENT";
/** Checks if bus message is of a track event type */
export var isTrackEvent = function isTrackEvent(m) {
  return (m === null || m === void 0 ? void 0 : m.type) === TYPE;
};
export var trackEvent = function trackEvent(_ref) {
  var _window, _window$location;
  var name = _ref.name,
    appName = _ref.appName,
    experimentInfo = _ref.experimentInfo,
    target = _ref.target,
    action = _ref.action,
    customInfo = _ref.customInfo,
    tag = _ref.tag,
    purposes = _ref.purposes;
  return {
    type: TYPE,
    payload: {
      name: name,
      target: target,
      tag: tag,
      action: action,
      appName: appName,
      experimentInfo: experimentInfo,
      id: nanoid(),
      purposes: purposes,
      source: (_window = window) !== null && _window !== void 0 && (_window$location = _window.location) !== null && _window$location !== void 0 && _window$location.href ? window.location.href : "",
      customInfo: customInfo
    }
  };
};